'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "restricted", "disabled", "readOnly", "left", "width"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { KOALA, BATTLESHIP, CALYPSO } from 'HubStyleTokens/colors';
import { omitProps } from '../../utils/Props';
import { toPercent, toPx } from '../../utils/Styles';

// avoid setting props w/ same names as valid HTML attributes (like `width`) on div
import { jsx as _jsx } from "react/jsx-runtime";
const CleanDiv = omitProps(props => /*#__PURE__*/_jsx("div", Object.assign({}, props)), ['left', 'lineStyle', 'width', 'color', 'restricted', 'disabled']);
export const getTrackColorFromProps = props => {
  const {
    value,
    disabled,
    restricted,
    readOnly
  } = props;
  if (value <= 0) {
    if (disabled || readOnly) {
      return KOALA;
    }
    if (!restricted) {
      return CALYPSO;
    }
  }
  return BATTLESHIP;
};
const BORDER_WIDTH_BY_SIZE = {
  md: 1,
  lg: 2
};
const getBorderWidthForSize = size => BORDER_WIDTH_BY_SIZE[size] || 0;
const UISliderTrackLine = styled(CleanDiv).withConfig({
  displayName: "UISliderTrack__UISliderTrackLine",
  componentId: "sc-1ff9nkf-0"
})(["border-color:", ";border-style:", ";border-width:", ";margin:0 ", ";"], props => props.color, props => props.lineStyle, props => toPx(getBorderWidthForSize(props.size)), props => toPx(getBorderWidthForSize(props.size)));
if (process.env.NODE_ENV !== 'production') {
  UISliderTrackLine.propTypes = {
    color: PropTypes.string,
    lineStyle: PropTypes.oneOf(['solid', 'dashed']),
    size: PropTypes.oneOf(['md', 'lg'])
  };
}
const UISliderTrackContainer = styled(CleanDiv).withConfig({
  displayName: "UISliderTrack__UISliderTrackContainer",
  componentId: "sc-1ff9nkf-1"
})(["position:absolute;top:0;bottom:0;left:", ";width:", ";cursor:", ";& ", "{position:absolute;top:", ";right:0;left:0;}"], props => toPercent(props.left), props => toPercent(props.width), props => props.restricted || props.disabled ? 'not-allowed' : undefined, UISliderTrackLine, props => props.size === 'lg' ? '8px' : '6px');
if (process.env.NODE_ENV !== 'production') {
  UISliderTrackContainer.propTypes = {
    left: PropTypes.number,
    width: PropTypes.number,
    size: PropTypes.oneOf(['md', 'lg']),
    disabled: PropTypes.bool,
    restricted: PropTypes.bool,
    readOnly: PropTypes.bool
  };
}
export const UISliderTrackSegment = props => {
  const {
      size,
      restricted,
      disabled,
      readOnly,
      left,
      width
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const color = getTrackColorFromProps(props);
  const lineStyle = props.restricted ? 'dashed' : 'solid';
  return /*#__PURE__*/_jsx(UISliderTrackContainer, Object.assign({
    size: size,
    left: left,
    width: width,
    disabled: disabled,
    readOnly: readOnly,
    restricted: restricted
  }, rest, {
    children: /*#__PURE__*/_jsx(UISliderTrackLine, {
      size: size,
      color: color,
      lineStyle: lineStyle
    })
  }));
};
UISliderTrackSegment.propTypes = Object.assign({}, UISliderTrackContainer.propTypes, {
  value: PropTypes.oneOf([-1, 0, 1])
});
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISliderTrackSegment.defaultProps = {
  value: 0,
  size: 'md',
  disabled: false,
  restricted: false
};
UISliderTrackSegment.displayName = 'UISliderTrackSegment';